export const TOKEN_KEY = "Authorization"
export const TOKEN_TYPE="Bearer "

export const PROTOCOL_TYPE = {
    1: '隐私政策',
    2: '小区服务政策',
    3: '用户协议'
}

export const RESULT_TYPES = {
    activity: {
        name: 'activity',
        result: "提交成功",
        resultSub:
          "如有人数超限等特殊情况导致报名失败，活动方将致电联系您沟通相关事宜。",
        confirm: "查看报名",
        detailRouter: "ActivityOrderDetail"
    },
    questionnaire: {
       name: 'questionnaire',
       result: "提交成功",
       resultSub:"已完成问卷，感谢参与",
       confirm: "查看结果",
       detailRouter: "QuestionnaireRecordDetail"
    },
    vote: {
        name: 'vote',
        result: "投票成功",
       resultSub:"已完成投票，感谢参与",
       confirm: "查看投票结果",
       detailRouter: "VoteRecordDetail"
    }
}

export const DOWNLOAD_APP_URL = 'http://download.jiayoushenghuojia.com/'